import { importWhenVisible } from '@studiometa/js-toolkit';
import { Transition, LargeText } from '@studiometa/ui';
import { untrapFocus, trapFocus } from '@studiometa/js-toolkit/utils';

/**
 * Cart component
 * @see https://liquid-ajax-cart.js.org/v2/
 */
export default class Cart extends Transition {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Cart',
    refs: ['close[]'],
    components: {
      LargeText,
      CrossSellSlider: (app) =>
        importWhenVisible(
          () => import('../../Sections/CrossSellSlider.js'),
          'CrossSellSlider',
          app,
        ),
    },
  };

  isOpen = false;

  /**
   * mounted
   */
  mounted() {
    document.addEventListener('liquid-ajax-cart:request-end', (event) => {
      const { requestState } = event.detail;

      if (requestState.requestType === 'add' && requestState.responseData?.ok) {
        this.open();
        this.$children.CrossSellSlider[0].$update();
      }

      if (!requestState.responseData?.ok) {
        this.$root.Toaster.addToast(requestState.responseData?.body?.message);
      }

      this.$update();
    });
  }

  /**
   * Focus trap when Cart is open
   * @param {boolean} ESC Will be true if the key initiating the event is the esc key.
   */
  keyed({ event, isDown, isUp, ESC }) {
    if (!this.isOpen) {
      return;
    }

    if (isDown) {
      trapFocus(document.body, event);
    }

    if (ESC && isUp) {
      this.close();
    }
  }

  /**
   * onCloseClick
   */
  onCloseClick() {
    this.close();
  }

  /**
   * open fn
   */
  open() {
    document.addEventListener('keyup', (event) => {
      trapFocus(this.$el, event);
    });
    this.isOpen = true;
    this.enter();
    document.body.classList.add('overflow-hidden');
    this.$el.setAttribute('aria-hidden', 'false');
    this.$el.removeAttribute('inert');
  }

  /**
   * close fn
   */
  close() {
    untrapFocus();
    this.isOpen = false;
    this.leave();
    document.body.classList.remove('overflow-hidden');
    this.$el.setAttribute('aria-hidden', 'true');
    this.$el.setAttribute('inert', '');
  }
}
